export default "__VITE_ASSET__$e4K0_cN__"